/**
 * Header : état scrolled + drawer mobile.
 */
export default function initHeader() {
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const navToggle = document.querySelector('.site-nav__toggle');
  const navPanel = document.querySelector('.site-nav__panel');

  if (!navToggle || !navPanel) {
    return;
  }

  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  const labelOpen = navToggle.getAttribute('data-label-open') || 'Ouvrir le menu';
  const labelClose = navToggle.getAttribute('data-label-close') || 'Fermer le menu';

  const setExpanded = (open) => {
    navToggle.setAttribute('aria-expanded', String(open));
    navToggle.setAttribute('aria-label', open ? labelClose : labelOpen);
    navPanel.classList.toggle('is-open', open);
    navPanel.toggleAttribute('inert', !open);
    if (header) {
      header.classList.toggle('is-nav-open', open);
    }
    document.documentElement.classList.toggle('is-nav-open', open);
  };

  const closePanel = () => {
    if (navPanel.classList.contains('is-open')) {
      setExpanded(false);
      navToggle.focus();
    }
  };

  const openAccordion = (item, open) => {
    const btn = item.querySelector('.site-nav__more');
    item.classList.toggle('is-open', open);
    if (btn) {
      btn.setAttribute('aria-expanded', String(open));
    }
  };

  navToggle.addEventListener('click', () => {
    setExpanded(navToggle.getAttribute('aria-expanded') !== 'true');
  });

  navPanel.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      if (!mqDesktop.matches) {
        closePanel();
      }
    });
  });

  navPanel.querySelectorAll('.site-nav__more').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const item = btn.closest('.site-nav__item--has-submenu');
      if (!item) {
        return;
      }
      const willOpen = !item.classList.contains('is-open');
      navPanel.querySelectorAll('.site-nav__item--has-submenu.is-open').forEach((openItem) => {
        if (openItem !== item) {
          openAccordion(openItem, false);
        }
      });
      openAccordion(item, willOpen);
    });
  });

  navPanel.querySelectorAll('.site-nav__item--has-submenu').forEach((item) => {
    if (item.querySelector('.is-active')) {
      openAccordion(item, true);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closePanel();
    }
  });

  const onDesktopChange = (e) => {
    if (e.matches) {
      closePanel();
    }
  };
  if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener('change', onDesktopChange);
  } else {
    mqDesktop.addListener(onDesktopChange);
  }

  setExpanded(false);
}
